import * as React from 'react';
import type { Location } from '@hetivo/hetivo-lib-types';
import { cn } from '@hetivo/hetivo-lib-web-utils';
import { MapPin } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useMasterContext } from '&/master';

// ─── Props ────────────────────────────────────────────────────────────────────

export interface LocationResultProps {
  location: Location;
  onClose: () => void;
}

// ─── Component ────────────────────────────────────────────────────────────────

export function LocationResult({ location, onClose }: LocationResultProps): React.JSX.Element {
  const { selectSite, siteId: currentLocationId } = useMasterContext();
  const { t } = useTranslation('common');
  const isActive = location.id === currentLocationId;

  const handleSelect = (): void => {
    selectSite(location.id, location.territoryId);
    onClose();
  };

  return (
    <button
      className={cn(
        'flex items-center gap-2 px-2.5 py-2 mx-1 w-[calc(100%-0.5rem)] rounded-md transition-colors text-left group/location-result',
        isActive ? 'bg-accent' : 'hover:bg-muted',
      )}
      onClick={handleSelect}
      type="button"
    >
      <MapPin className="w-3.5 h-3.5 shrink-0" style={{ color: location.color }} />
      <span className="flex-1 text-xs truncate">{location.name}</span>
      {!isActive && (
        <span className="text-[11px] text-primary font-medium hidden group-hover/location-result:inline">
          {t('mainSelector.select')}
        </span>
      )}
    </button>
  );
}
